(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/betslip/betslip-sticky-content.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/betslip/betslip-sticky-content.js');
"use strict";

const {
  SignSeparators
} = svs.challenge;
const {
  ReactIcon
} = svs.ui;
const {
  dialog
} = svs.components;
const {
  helpTexts
} = svs.challenge.data.config;
const BetslipStickyContent = _ref => {
  let {
    drawEvents,
    rowPrice
  } = _ref;
  function handleHelpButtonClick(e) {
    e.stopPropagation();
    if (helpTexts) {
      dialog.api.add(new dialog.Contextual({
        attachTo: e.currentTarget,
        branding: dialog.branding.SPORT,
        message: [{
          text: helpTexts.price.body,
          type: dialog.message.TEXT
        }],
        title: helpTexts.price.title,
        zIndex: 1100
      }));
    }
  }
  return React.createElement("div", {
    className: "challenge-betslip-sticky-content"
  }, React.createElement(SignSeparators, {
    drawEvents: drawEvents,
    rowPrice: rowPrice
  }), React.createElement("button", {
    className: "align-middle icon-button padding-xs-h js-betslip-help",
    onClick: handleHelpButtonClick,
    type: "button"
  }, React.createElement(ReactIcon, {
    color: "icon-inverted fc-sport",
    icon: "help",
    size: "300"
  })));
};
svs.challenge.BetslipStickyContent = BetslipStickyContent;

 })(window);